import script from "./DocumentDocuments.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentDocuments.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentDocuments.vue?vue&type=style&index=0&id=18f7b548&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f7b548"]])

export default __exports__